import * as React from 'react';
import { Dialog, Container } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import CompletedViewPreview from './CompletedViewPreview';

interface OwnProps {
	open: boolean;
	onClose: () => void;
	completeViewProps: React.ComponentProps<typeof CompletedViewPreview>;
}

type Props = OwnProps;

const useStyles = makeStyles({
	container: {
		padding: 0,
	},
});

const CompletedViewPreviewDialog: React.FC<Props> = (props) => {
	const classes = useStyles();
	const { open, onClose, completeViewProps } = props;

	return (
		<Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
			<Container className={classes.container}>
				<CompletedViewPreview
					{...completeViewProps}
					button="collapseButton"
					handleCloseDialog={onClose}
					buttonSize={48}
					scale={1}
				/>
			</Container>
		</Dialog>
	);
};

export default CompletedViewPreviewDialog;
